import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import networksSvg from 'assets/icons/networks.svg';
import { Option } from 'components/common/types/DropdownItem.types';
import { Store } from 'components/common/types/Store.types';
import { BaseSelectMultiLevel } from 'lib/BaseSelect';
import { NetworkItem } from 'components/pages/AvailabilityReport/AddFilter/AddFilter.types';
import { transformNetworkData } from 'components/pages/AvailabilityReport/AddFilter/networkUtils';
import { updateSelectedNetworks } from 'components/pages/AvailabilityReport/AddFilter/networkFilterUtils';

interface FilterNetworksProps {
  selectedNetworks?: NetworkItem[];
  changeFilters: (filters: { networks?: NetworkItem[] }) => void;
  isDisabled?: boolean;
}

const FilterNetworks: React.FC<FilterNetworksProps> = ({
  selectedNetworks = [],
  changeFilters,
  isDisabled = false,
}) => {
  const referenceNetworkData = useSelector((state: Store) => state.userOptions.networks);
  const isLoading = useSelector((state: Store) => state.dealManagement.isFetchingReferences);

  const networkOptions: Option[] = useMemo(() => {
    if (isLoading || !referenceNetworkData) return [];
    return transformNetworkData(referenceNetworkData);
  }, [referenceNetworkData, isLoading]);

  const selectedNetworkCodes = useMemo(() => {
    return selectedNetworks.map((network) => network.code);
  }, [selectedNetworks]);

  const handleNetworksChange = (node: Option, checked: boolean): void => {
    const updatedNetworks = updateSelectedNetworks(node, checked, selectedNetworks, networkOptions);
    changeFilters({ networks: updatedNetworks });
  };

  return (
    <BaseSelectMultiLevel
      options={networkOptions}
      value={selectedNetworkCodes}
      onChangeItem={handleNetworksChange}
      isDisabled={isDisabled || isLoading}
      dataTestId="networks-multi-level-dropdown"
      icon={networksSvg}
      placeholder="Networks"
      classNameWrapper="w-52"
      selectedLabel="Networks"
    />
  );
};

export default FilterNetworks;
